import script from "./tenant-switch-progress.vue?vue&type=script&setup=true&lang=ts"
export * from "./tenant-switch-progress.vue?vue&type=script&setup=true&lang=ts"

import "./tenant-switch-progress.vue?vue&type=style&index=0&id=d21eb17e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d21eb17e"]])

export default __exports__